<script>export let definition;
</script>

<div class="launcher {definition.name}" data-name={definition.name}>
	<a class="btn tlmd-launcher {definition.name}" on:click|stopPropagation  href="{definition.options && definition.options.url ? definition.options.url : '#top'}" target="{definition.options && definition.options.target ? definition.options.target : 'external'}"><span class={definition.icon}></span></a
	><span class="tlmd-label">{definition.label}</span>
</div>

<style>
div.launcher > span.tlmd-label {
	display: block;
	font: inherit;
	margin-left: 0.125rem;
	margin: 0.1872rem 0.2rem 0.5rem 0.2rem;
	border-top: 0.1875rem solid transparent;
}    
</style>